var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootsteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_617_445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.09131 6.14483C1.73803 6.14483 1.45069 6.01717 1.23522 5.76374C1.01975 5.5103 0.878346 5.13421 0.796002 4.58702C0.674752 3.78061 0.795065 3.10092 1.13475 2.67327C1.33475 2.42139 1.59725 2.27577 1.89381 2.25233C2.14772 2.23202 2.52725 2.33499 2.89382 2.93983C3.12335 3.31858 3.29788 3.82171 3.37272 4.32014C3.46319 4.92186 3.39585 5.36483 3.16678 5.67405C2.98491 5.91967 2.70522 6.07186 2.33538 6.12717C2.25457 6.13904 2.17299 6.14494 2.09131 6.14483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.70333 8.25004C2.49693 8.25004 2.28771 8.18394 2.09927 8.05691C1.82735 7.87265 1.63913 7.58853 1.57552 7.26629C1.53099 7.03722 1.55771 6.85519 1.65708 6.70941C1.81849 6.47269 2.10818 6.41941 2.41474 6.36285C2.44708 6.35691 2.47989 6.35097 2.51318 6.34457C2.5838 6.33113 2.65599 6.31332 2.72599 6.29597C2.98818 6.23129 3.25943 6.16425 3.48333 6.32332C3.63318 6.42957 3.71771 6.61019 3.74302 6.87519C3.77177 7.18097 3.70614 7.48613 3.55818 7.73457C3.39896 8.00191 3.16021 8.17863 2.8863 8.23238C2.82602 8.24415 2.76475 8.25006 2.70333 8.25004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90882 4.64489C5.82722 4.64461 5.74575 4.63834 5.66507 4.62614C5.29538 4.57145 5.01569 4.41911 4.83382 4.17301C4.60475 3.86379 4.53694 3.42098 4.62788 2.81911C4.70272 2.3202 4.87678 1.81754 5.10522 1.4402C5.46991 0.837543 5.84991 0.733012 6.10522 0.751449C6.40085 0.773012 6.66288 0.916605 6.86319 1.16707C7.20522 1.59473 7.32647 2.27645 7.20475 3.08645C7.12241 3.63332 6.98288 4.00754 6.76553 4.26317C6.54819 4.51879 6.2621 4.64489 5.90882 4.64489Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.29681 6.75011C5.23555 6.75011 5.17443 6.74419 5.11431 6.73246C4.83993 6.67871 4.60118 6.50199 4.44243 6.23465C4.29446 5.98621 4.22884 5.68105 4.25759 5.37527C4.28259 5.10965 4.36696 4.92965 4.51728 4.82324C4.74118 4.66433 5.01243 4.73121 5.27462 4.79605C5.34462 4.81324 5.41681 4.83105 5.48743 4.84465L5.58571 4.86293C5.89243 4.91933 6.18212 4.9723 6.34353 5.20933C6.4429 5.35511 6.46962 5.53746 6.42509 5.76621C6.36153 6.08852 6.1733 6.37271 5.90134 6.55699C5.71181 6.68418 5.50259 6.75011 5.29681 6.75011Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_617_445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootsteps);
export default __webpack_public_path__ + "static/media/footsteps.26be9e792d840d3a5e721e5ab608824a.svg";
export { ForwardRef as ReactComponent };